import React from "react";
import { useGetUsersQuery } from "../api/UserApi";
import { useUtilitiesContext } from "../contexts/UtilitiesContext";

export default function useGetUserHook() {
    const { showNotification } = useUtilitiesContext();
    
    const {
        data: users,
        isError: isUsersError,
        error: usersError,
        isFetching: isUsersFetching,
        refetch: refetchUsers
    } = useGetUsersQuery();

    React.useEffect(() => {
        if (isUsersError) {
            showNotification({
                type: "error",
                title: "Error",
                message: usersError?.message,
            });
        }
    }, [isUsersError, usersError, showNotification]);

    return {
        users,
        isUsersError,
        usersError,
        isUsersFetching,
        refetchUsers
    };
}